import { ISignInState } from 'src/app/store/state/auth.signin.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAuthState } from '../../state/auth.state';
import { IChangePasswordState } from '../../state/auth.changepassword.state';

export const getAuthState = createFeatureSelector<IAuthState>('auth');

export const getSignInState = createSelector(
    getAuthState,
    (state: IAuthState) => state.signIn
);

export const getSignInFailText = createSelector(
    getSignInState,
    (state: ISignInState) => state.authFailText
);


export const getResetPasswordState = createSelector(
    getAuthState,
    (state: IAuthState) => state.resetPassword
);

export const selectSignInAdvisorId = createSelector(
    getAuthState,
    (state: IAuthState) => state.signIn.advisorId
);

export const getChangePasswordState = createSelector(
    getAuthState,
    (state: IAuthState) => state.changePassword
);

export const selectChangePasswordLoading = createSelector(
    getChangePasswordState,
    (state: IChangePasswordState) => state.loading
);

export const getHasFalseInception = createSelector(
    getAuthState,
    (state: IAuthState) => state.signIn.hasFalseInception
);
